import { BookmarkButton, Login, SongStep } from '../containers'
import React, { Fragment, useContext, useEffect, useState } from 'react';
import { gql, useQuery } from '@apollo/client';

import { Button } from 'react-bulma-components';
import DefaultError from '../components/defaulterror';
import { Loader } from '../components';
import NotFound from '../components/notfound';
import PageTitle from '../components/pagetitle';
import { Steps } from '../components';
import _ from 'lodash';
import { navigate } from '@reach/router';
import { useAuth } from 'react-oidc-context';
import { useGlobalState } from '../state';

export const GET_SONG = gql`
  query GetSong($slug: String!) {
    songBySlug(slug: $slug){
      ... on Song {
      slug
      type
      description
      level
      noofsteps
      stepids
      title
      skipInstrumentTransponation
      isBookmarked
    }
    ... on SongNotFoundError{
      message
    }
  }
  }
`;

function PageContent({slug, stepid, skipInstrumentTransponation}) {
  const auth = useAuth();
  if(!auth.isAuthenticated){
    return <Login />;
  }
  else
  {
    // key={stepid} forces a fresh mount (and a fresh useQuery) per step —
    // the Apollo Client version here doesn't reliably clear a previous
    // step's GraphQL error when switching to a step that succeeds.
    return stepid?<SongStep key={stepid} slug={slug} stepid={stepid} skipInstrumentTransponation={skipInstrumentTransponation}/>:null;
  }
}

export default function Song({ slug }) {
  const [currentStep, setCurrentStep] = useState(1);
  const [, setPageContext] = useGlobalState('pageContext');
  const { data, loading, error } = useQuery(
    GET_SONG,
    {
      variables: { slug: slug },
      // fetchPolicy: "no-cache"
     }
  );

  // Let BugReportButton (rendered app-wide, outside this page) know which
  // song/fact and step the user is currently on.
  useEffect(() => {
    if (data?.songBySlug && data.songBySlug.__typename !== 'SongNotFoundError') {
      setPageContext({
        type: data.songBySlug.type,
        title: data.songBySlug.title,
        slug: data.songBySlug.slug,
        step: currentStep,
        totalSteps: data.songBySlug.noofsteps,
      });
    }
    return () => setPageContext(null);
  }, [data, currentStep, setPageContext]);

  const handleStepNavigation = (index) => {
    setCurrentStep(index);
  }

  if (loading) return (
    <Fragment>
      <PageTitle>
        <Loader />
      </PageTitle>
    </Fragment>
  );
/*   if(_.get(error,"graphQLErrors[0].extensions.code")==="FORBIDDEN"){
    return (
      <p>{error.message}</p>
    )
  } */
  if (error)
  { 
    return (
    <Fragment>
        <DefaultError error={error} />
      </Fragment>
    ); 
  }

if(data.songBySlug.__typename==="SongNotFoundError"){
  return(
    <NotFound message={data.songBySlug.message} />
    )
}
   const isSong = data.songBySlug.type==="song";

   return (
    <Fragment>
      <PageTitle name={data.songBySlug.title}
        description={data.songBySlug.description}
        isSong={isSong}
        color={isSong?'primary':'info'}
        levelIndicator={{ level: data.songBySlug.level }}
        bookmarkButton={
          <BookmarkButton
            slug={data.songBySlug.slug}
            type={data.songBySlug.type}
            isBookmarked={data.songBySlug.isBookmarked}
          />
        }
        // Edit button if Admin
        adminbuttons={[
           <Button color="primary" 
            type="button" 
            onClick={() => {
              if(isSong){
                navigate(`/song-edit/${data.songBySlug.slug}`)
              }
              else{
                navigate(`/fact-edit/${data.songBySlug.slug}`)
              }
            }}
          >Edit</Button>
        ]}
      />
      <Steps noOfSteps={data.songBySlug.noofsteps} active={currentStep} setCurrentStep={handleStepNavigation}/>
      <PageContent slug={slug} stepid={data.songBySlug.stepids[currentStep-1]} skipInstrumentTransponation={data.songBySlug.skipInstrumentTransponation}/>
    </Fragment>
  );
}
